import { ageLevel } from '@/utils/relativeTime';

// Filter-Panels der Stammdaten (Kundenwunsch 13.10.2026: „die seiten unter stammdaten gemäß der anderen überarbeiteten
// seiten wie titel buttons tabellen überarbeiten“): dieselben Funktionen wie Verkäufe und Zahlungen (saleFilters.js),
// mit eigenen Umschaltern (segments) und Listen. Gefiltert wird im Browser über die geladenen Zeilen.

function isOne(value) {
  return value === true || value === 1 || value === '1';
}

// Geräte: Status (vorher Filterzeile mit „Aktiv“ vorbelegt), Testgerät, Zahlungsanbieter, App-Version und Letzter Upload
export const DEVICE_FILTER_CONFIG = {
  segments: [
    {
      key: 'status',
      label: 'Status',
      items: [{ value: 'aktiv', text: 'Aktiv' }, { value: 'inaktiv', text: 'Inaktiv' }, { value: null, text: 'Alle' }],
      defaultValue: 'aktiv',
      match: (value, row) => (value === 'aktiv' ? isOne(row.active) : !isOne(row.active))
    },
    {
      key: 'test',
      label: 'Testgeräte',
      items: [{ value: null, text: 'Alle' }, { value: 'ohne', text: 'Ohne' }, { value: 'nur', text: 'Nur' }],
      match: (value, row) => (value === 'nur' ? isOne(row.is_test_device) : !isOne(row.is_test_device))
    }
  ],
  lists: [
    { key: 'providers', field: 'payment_provider', label: 'Zahlungsanbieter' },
    { key: 'versions', field: 'app_version', label: 'App-Version' },
    // Alter des letzten Uploads (Kundenwunsch 27.10.2026); Schlüssel absteigend sortiert = jüngste zuerst
    { key: 'upload', label: 'Letzter Upload', value: (row) => UPLOAD_AGE_KEY[ageLevel(row.last_upload)], sortByKey: true }
  ],
  amountField: null,
  amountLabel: ''
};

// Filterliste „Letzter Upload“: Schlüssel je Altersstufe (ageLevel) und Text
const UPLOAD_AGE_KEY = { fresh: '4', stale: '3', old: '2', never: '1' };
export const UPLOAD_AGE_TEXT = { 4: 'unter 24 Stunden', 3: '1–7 Tage', 2: 'älter als 7 Tage', 1: 'nie' };

// Superadmin „Geräte“ aller Kunden (Kundenwunsch 13.10.2026: „superadminseiten bitte ebenfalls umstellen“; vorher
// Filterzeile mit „Aktiv“ vorbelegt): Status, Testgerät, SumUp; Liste Kunde
export const ADMIN_DEVICE_FILTER_CONFIG = {
  segments: [
    {
      key: 'status',
      label: 'Status',
      items: [{ value: 'aktiv', text: 'Aktiv' }, { value: 'inaktiv', text: 'Inaktiv' }, { value: null, text: 'Alle' }],
      defaultValue: 'aktiv',
      match: (value, row) => (value === 'aktiv' ? isOne(row.active) : !isOne(row.active))
    },
    {
      key: 'test',
      label: 'Testgeräte',
      items: [{ value: null, text: 'Alle' }, { value: 'ohne', text: 'Ohne' }, { value: 'nur', text: 'Nur' }],
      match: (value, row) => (value === 'nur' ? isOne(row.is_test_device) : !isOne(row.is_test_device))
    },
    {
      key: 'sumup',
      label: 'SumUp',
      items: [{ value: null, text: 'Alle' }, { value: 'mit', text: 'Mit' }, { value: 'ohne', text: 'Ohne' }],
      match: (value, row) => (value === 'mit' ? isOne(row.enable_sumup) : !isOne(row.enable_sumup))
    }
  ],
  lists: [
    {
      key: 'customers',
      label: 'Kunde',
      value: row => (row.customer_id === null || row.customer_id === undefined ? null
        : [row.customer_id, row.cust_printname].filter(v => v !== null && v !== undefined && v !== '').join(' – '))
    }
  ],
  amountField: null,
  amountLabel: ''
};

// Benutzer: Status (vorher Umschalter in der Werkzeugleiste, „Aktiv“ vorbelegt) und Rolle (vorher Auswahl)
export const USER_FILTER_CONFIG = {
  segments: [
    {
      key: 'status',
      label: 'Status',
      items: [{ value: 'active', text: 'Aktiv' }, { value: 'inactive', text: 'Inaktiv' }, { value: null, text: 'Alle' }],
      defaultValue: 'active',
      match: (value, row) => (value === 'active' ? isOne(row.active) : !isOne(row.active))
    }
  ],
  lists: [{ key: 'roles', field: 'role', label: 'Rolle' }],
  amountField: null,
  amountLabel: ''
};
